module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Link to share the list","copy":"Copy","copied":"Copied"},"de":{"label":"Link zum teilen der Liste","copy":"Kopieren","copied":"Kopiert"}}')
  delete Component.options._Ctor
}
